<template>
    <div>
        <el-dialog v-model="examStartPromptyShow" title="Tips" width="500" :close-on-click-modal="false" :show-close="false" :align-center="true">
            <template #header>
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="20">
                        <CloseBold />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content flex flexcolumn Flexalign">
                <el-image class="exam_start_prompty mt-40" :src="imgPath('exam_start_prompty.png')"></el-image>
                <div class="promty_text mt-30">当前考试<span class="blue_active">已开启防切屏</span>，您即将进入<span
                        class="blue_active">全屏考试</span></div>
                <div class="promty_sub_text mt-20">（退出全屏将判定为切屏一次，请勿退出全屏）</div>
                <div class="btn_start mt-50 cursor_pointer" @click="handleFullScreen">进入全屏，开始考试</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "GjkcH5ExamStartPrompty",

    data() {
        return {
            examStartPromptyShow: false,
            fullscreen: false,
        };
    },

    mounted() { },

    methods: {
        closePopup() {
            this.examStartPromptyShow = false;
            this.handleFullScreen();
        },
        // 进入全屏
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
            this.examStartPromptyShow = false;

            // 触发考试开始事件
            this.$emit('exam-started');
        }
    }
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 0;
    width: 802px;
    height: 505px;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: start;
}

.header {
    //   text-align: center;
    //   font-weight: bold;
    font-size: 20px;
    color: #333333;
    line-height: 60px;
    border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #333333;
}

.dialog_content {
    .exam_start_prompty {
        width: 644px;
        height: 225px;
    }

    .promty_text {
        font-weight: bold;
        font-size: 24px;
        color: #303030;

        .blue_active {
            color: #3FADFD;
        }
    }

    .promty_sub_text {
        font-size: 18px;
        color: #909090;
    }

    .btn_start {
        width: 227px;
        height: 48px;
        background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
        border-radius: 30px;
        line-height: 48px;
        text-align: center;
        color: #fff;
    }
}
</style>